// /src/App.js
import React, { useState, useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import TabbedFilesAndRecords from "./components/TabbedFilesAndRecords";
import Login from "./components/Login";

function App() {
  const [token, setToken] = useState(null);

  // Restore token from localStorage on page load
  useEffect(() => {
    const savedToken = localStorage.getItem("token");
    if (savedToken) {
      setToken(savedToken);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
  };

  // If not logged in, show login page
  if (!token) {
    return <Login onLogin={setToken} />;
  }

  // If logged in, show dashboard
  return (
    <Container maxWidth="lg" style={{ marginTop: "2rem" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
          File Management
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>

      <TabbedFilesAndRecords />
    </Container>
  );
}

export default App;
